import React, { useState, useEffect }  from 'react';
import styles from './wrapupbuttonwithdialog.css';
import { Button} from '@momentum-ui/react';
import WrapupDialog from '../../wrapupdialog/index';
import PropTypes from 'prop-types';
import Timer from '../../timer';
import ComponentsUtil, {KeyCodes} from '../../../utils/ComponentsUtil';
import {i18n} from '../../../utils/GadgetUtils';

const WrapupButtonWithDialog = (props) => {
    console.log(':: WrapupButtonWithDialog props ', props);

	const [showWrapupDialog, setShowWrapupDialog] = useState(false);
	const [showWrapupEnabled, setShowWrapupEnabled] = useState(props.selectedWrapupReason && !props.wrapUpApplyError);
	const [selectedWrapupOption, setSelectedWrapupOption] = useState(props.selectedWrapupReason);
	const [showSpinner, setShowSpinner] = useState(false);

	const shouldDisableWrapupButton = () => !(props.wrapUpReasons && props.wrapUpReasons.options && props.wrapUpReasons.options.length > 0) || props.isDisabled;

    const getWrapupAriaLabelWithApplied = () => `
        ${i18n.getMsg('gadget.imi.operation.WrapUp.arialabel')}
        ${props.selectedWrapupReason ? `, ${i18n.getMsg('gadget.imi.screenreader.applied')}` : ''}
    `;

    const handleWrapupButtonClick = (evt) => {
        evt.stopPropagation();
        evt.preventDefault();
        setShowWrapupDialog(!showWrapupDialog);
        setSelectedWrapupOption(props.selectedWrapupReason);
        setShowWrapupEnabled(props.selectedWrapupReason && !props.wrapUpApplyError);
	}	

    useEffect(() => {
        setShowWrapupEnabled(props.selectedWrapupReason && !props.wrapUpApplyError);
        setShowWrapupDialog(props.wrapUpApplyError);
        setSelectedWrapupOption(props.selectedWrapupReason);
        setShowSpinner(false);
    }, [props.selectedWrapupReason, props.wrapUpApplyError]);

    const handleApplyClick = (e) => {
       	if (selectedWrapupOption === props.selectedWrapupReason) return false;
        ComponentsUtil.setFocusByElementID('button-wrapup-' + props.id);
        setShowSpinner(true);
        setShowWrapupDialog(false);
		props.wrapupApplyCallback(selectedWrapupOption);
	}

    const onDismissWrapupDialog = () => {
        setShowWrapupDialog(false);
        setSelectedWrapupOption(props.selectedWrapupReason);
        setShowWrapupEnabled(props.selectedWrapupReason && !props.wrapUpApplyError);
	}

    const toggleWrapupSelection = (option) => {
        setShowWrapupEnabled(false);
        setSelectedWrapupOption(option);
	}

    const handleKeyDown = e => {
		/* Open the Wrap up popover also on click on Arrow down key */
		if (e.keyCode === KeyCodes.KEY_DOWN) {
			setShowWrapupDialog(true);
		}
	}

	const shouldDisableApply = !selectedWrapupOption || selectedWrapupOption === props.selectedWrapupReason;

	return (
		<div onKeyDown={handleKeyDown}>
		<Button
			className={styles.taskHeaderButton}
			active={showWrapupDialog}
			children={[
				<md-icon key={`wrapup-success-${props.id}`} name='icon-check-circle-active_16' color={`${shouldDisableWrapupButton() ? '#b2b2b2' : '#00823B' }`}
								style={{ marginRight: "9px",
								display: `${showWrapupEnabled ? "flex" : "none" }` }}/>,
				<md-icon key={`wrapup-error-${props.id}`} name='icon-clear-active_16' color={`${shouldDisableWrapupButton() ? '#b2b2b2' : '#D4371C' }`}
								style={{ marginRight: "9px",
								display: `${props.wrapUpApplyError ? "flex" : "none"}` }}/>,
				<span key={`wrapup-label-${props.id}`}>{i18n.getMsg('gadget.imi.operation.wrapUpReasons')}</span>,
				<span key={`wrapup-span-${props.id}`} id={`wrapup-span-${props.id}`} style={{ marginLeft: "4px", 
					display: `${props.displayTimer ? "flex" : "none"}` }}>-</span>,
				props.displayTimer &&
				<Timer key={`wrapup-timer-${props.id}`} id={`wrapup-timer-${props.id}`}
				    displayFormat='hh:mm:ss'
								show={props.displayTimer}
				    className={styles.wrapupButtonTimer}
								startTime={props.startTime}
								type={props.countDown ? 'COUNT_DOWN' : 'COUNT_UP'} 
								isInterrupted = {props.isInterrupted} />,
				<md-icon key={`wrapup-arrow-${props.id}`} name={`${showWrapupDialog ? 'icon-arrow-up_16' : 'icon-arrow-down_16' }`}
								style={{ marginLeft: "9px", marginTop: "4px" }}/>
			]}
			ariaLabel={getWrapupAriaLabelWithApplied()} tabIndex="0"
			id={`button-wrapup-${props.id}`}
			disabled={shouldDisableWrapupButton()}
			size={40}
			onClick={handleWrapupButtonClick}/>
		{(!props.wrapUpReasons) ? null : <WrapupDialog
			show={showWrapupDialog}
			onDismiss={onDismissWrapupDialog}
			toggleWrapupSelection={toggleWrapupSelection}
			selectedWrapupOption={selectedWrapupOption}
			handleApplyClick={handleApplyClick}
			showSpinner={showSpinner}
			shouldDisableApply={shouldDisableApply}
			wrapUpReasons={props.wrapUpReasons}
			id={props.id}
			selectedWrapupReason={props.selectedWrapupReason}
			wrapUpApplyError={props.wrapUpApplyError}/>
		}
		</div>
	);
}

WrapupButtonWithDialog.propTypes = {
	/* Applied wrapup reason code */
	selectedWrapupReason: PropTypes.string,
	/* Callback to be invoked when wrapup apply button is clicked */
	wrapupApplyCallback: PropTypes.func,
	/* configured wrapup reasons for the logged in agent */
	wrapUpReasons: PropTypes.shape({
		options: PropTypes.array
	}),
	/* Unique call id */
	id: PropTypes.string,
	/* Boolean variable to indicate if some error has occured while applying reason  */
	wrapUpApplyError: PropTypes.bool,
	/* Boolean flag to indicate if wrapup button should be disabled */
	isDisabled: PropTypes.bool,
	/* Boolean flag to indicate if error should be displayed */
	showWrapupApplyError: PropTypes.bool,
	/* Have to disable all other buttons when keypad operation is in progress */
	disableButtons: PropTypes.bool,
	displayTimer: PropTypes.bool,
	startTime: PropTypes.number,
};

export default WrapupButtonWithDialog;
